import ReactMarkdown from "react-markdown";

const MD = ({ md }: any) => {
  return <ReactMarkdown>{md}</ReactMarkdown>;
};

export default MD;
